module.exports = __webpack_public_path__ + "img/flow-ui-design.0fd56f6e.svg";